import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { GdsFlyAir } from 'ts/flight/interfaces/FlightDetailsResponse';
import {} from 'utils/flight/i18n';
import { getLogoUrl } from 'utils/utils';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { dateFormat } from 'utils/shared/utils';
import { blobUrl } from 'constants/generic';

interface SegmentDetailsProps {
  gds: GdsFlyAir;
}

const SegmentDetails: FC<SegmentDetailsProps> = ({ gds }) => {
  const [t] = useTranslation();


  return (
    <div className="flight-details-segment">
      <div className="item short">
        <img src={getLogoUrl(blobUrl, gds.airline.code)} alt={gds.airline.desc} height={44} />
      </div>
      <div className="item short">
        <span className="text-bold">{t('flight.flight')}</span>
        <div>
          <span className="flight-number">
            {gds.airline.code} {gds.flightNumber}
          </span>
        </div>
      </div>
      <div className="item short">
        <span className="text-bold">{t('flight.departure_time')}</span>
        <span>{dateFormat(gds.departureDateTime, 'dd/MM HH:mm')}</span>
      </div>
      <div className="item long">
        <span className="text-bold">{t('flight.departure_airport')}</span>
        <span>
          <span className="text-bold">{gds.departureAirport.code}</span>
          <span> {gds.departureAirport.desc}</span>
        </span>
      </div>
      <div className="item short">
        <span className="text-bold">{t('flight.arrival_time')}</span>
        <span>{dateFormat(gds.arrivalDateTime, 'dd/MM HH:mm')}</span>
      </div>
      <div className="item long">
        <span className="text-bold">{t('flight.arrival_airport')}</span>
        <span>
          <span className="text-bold">{gds.arrivalAirport.code}</span>
          <span> {gds.arrivalAirport.desc}</span>
        </span>
      </div>
      <div className="item short">
        <span className="text-bold">{t('flight.aircraft')}</span>
        <span>{gds.aircraftType.code}</span>
      </div>
      {gds.availSeatsNo < 5 && gds.availSeatsNo > 0 && (
        <div className="item short">
          <span className="text-bold">{t('flight.seats_available_up')}</span>
          <span>{gds.availSeatsNo}</span>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(SegmentDetails, 'SegmentDetails');
